import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const whenToStartClay: BlogMetaData = {
  title: '粘土遊びはいつから？何歳から始める？安全な素材と始め方3ステップ',
  description:
    '粘土遊びはいつから始める？誤飲・アレルギーへの配慮と安全な姿勢、素材（小麦/米/油土）の比較、3分でできる始め方3ステップを年齢別にモンテッソーリ視点で解説します。',
  thumbnailUrl: '/img/blog-when-to-start-clay.webp',
  filePath: buildBlogFilePath('when-to-start-clay'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
